export default __webpack_public_path__ + "static/media/detail_big_11_2.dcdd1cde.jpg";